import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITileSection from 'UIComponents/tile/UITileSection';
import { atomicQueryUpdate } from 'automation-ui-routing/historyUtils';
import { useHistory } from 'react-router-dom';
import { SettingsOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/settingsOptions';
import { OPEN_QUERY_PARAM, REDIRECT_TO_PANEL } from 'automation-ui-canvas/components/flow-header/menu-bar/MenuBar';
import { EXPANDED } from 'automation-ui-canvas/constants/settings/SettingsParams';
import { ReviewOptionId } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/constants/MenuOptionIds';
import UISection from 'UIComponents/section/UISection';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ReviewableSetting = ({
  settingName,
  settingValue,
  settingSectionId,
  description
}) => {
  const history = useHistory();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(UITileSection, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h7",
          children: settingName
        }), /*#__PURE__*/_jsxs(Box, {
          display: "block",
          flexShrink: "0",
          marginInlineStart: "500",
          children: [typeof settingValue === 'boolean' && /*#__PURE__*/_jsx(UIBadge, {
            className: "m-x-1",
            use: settingValue ? 'oz' : 'koala',
            children: settingValue ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "platformReview.v2.settingsStep.setting.on"
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "platformReview.v2.settingsStep.setting.off"
            })
          }), /*#__PURE__*/_jsx(UIIconButton, {
            onClick: () => {
              atomicQueryUpdate({
                [OPEN_QUERY_PARAM]: SettingsOption.id,
                [EXPANDED]: settingSectionId,
                [REDIRECT_TO_PANEL]: ReviewOptionId
              }, [], history);
            },
            use: "transparent",
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "edit"
            })
          })]
        })]
      }), description && /*#__PURE__*/_jsx(UISection, {
        children: description
      })]
    })
  });
};
export default ReviewableSetting;